module.exports = __webpack_public_path__ + "img/2EAC9E_61EBE3_4DDDD1_43D1C6-256px.568112e3.png";